/**
 * @section 4.2.1.3
 */
import { CircularProgress, Theme } from "@material-ui/core";
import { t } from "i18next";
import React from "react";
import { QueryKey, UseQueryOptions } from "react-query";
import { Link } from "react-router-dom";
import useSearch, { SearchResult } from "./../../apihooks/useSearch";
import { useAppContext } from "./../../context/AppCtxProvider";
import useCreateLink from "./../../hooks/useCreateLink";
import { mea_t } from "./../../tplutils/utils";
import getElementTypePage from "./../../utils/getElementTypePage";
import tmodel from "./../../utils/translate";
import { makeThemedStyles } from "./../../viewcomponents/utils";
interface Props {
  search: string;
  handleSearch: (choice?: SearchResult) => void;
  setFocusedSearch: React.Dispatch<React.SetStateAction<boolean>>;
  period?: string;
  divisionId?: string;
}
const useStyles = makeThemedStyles("SearchBar", (theme: Theme) => ({
  searchResults: {
    borderRadius: "5%",
    "&:hover": {
      backgroundColor: "lightgray",
    },
  },
  resultTitle: {
    marginTop: "10px",
    color: "gray",
    fontSize: "16px",
  },
  resultName: {
    marginBottom: "10px",
    color: "#283b57",
    fontSize: "16px",
  },
  viewAllResults: {
    display: "block",
    border: "none",
    background: "none",
    color: "#283b57",
    margin: "auto",
    textAlign: "center",
  },
}));
const SearchResults = (props: Props) => {
  const classes = useStyles();
  const createLink = useCreateLink();
  const ctx = useAppContext();
  const { search, handleSearch, setFocusedSearch } = props;
  const resultsOnSearch = 5;
  const options: Omit<
    UseQueryOptions<
      {
        data: SearchResult[];
      },
      unknown,
      {
        data: SearchResult[];
      },
      QueryKey
    >,
    "queryKey" | "queryFn"
  > = {
    enabled: false,
  };
  const { data, isLoading, isPreviousData, refetch, error } = useSearch(
    search.toLowerCase(),
    options,
    {
      period: props.period,
      divisionId: props.divisionId,
    }
  );
  return (
    <div>
      {isLoading || isPreviousData ? <CircularProgress /> : null}
      {!isLoading &&
        data?.data?.map((res, index) =>
          index < resultsOnSearch ? (
            <Link
              to={createLink(getElementTypePage(res))}
              onClick={() => setFocusedSearch(false)}
              style={{ textDecoration: "none" }}
            >
              <div
                className={classes.searchResults}
                onClick={() => handleSearch(res)}
                onKeyDown={() => handleSearch(res)}
                aria-hidden="true"
              >
                <div className={classes.resultTitle}>
                  {tmodel(res.typename)}
                </div>
                <div className={classes.resultName}>
                  {mea_t("Name", res.JS_ATTR, ctx.language)}{" "}
                </div>
              </div>
            </Link>
          ) : (
            <></>
          )
        )}
      {!isLoading && data && data?.data?.length > resultsOnSearch && (
        <button
          className={classes.viewAllResults}
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => handleSearch()}
          onKeyDown={() => handleSearch()}
          type="button"
        >
          {t("view all results")}
        </button>
      )}
    </div>
  );
};
export default SearchResults;
